"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpResource = void 0;
/**
 * Simple wrapper for REST APIs.
 */
var HttpResource = /** @class */ (function () {
    function HttpResource(baseUrl, headers, tokenFunctions) {
        this.baseUrl = baseUrl;
        this.headers = __assign({ 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, headers);
        this.tokenFunctions = tokenFunctions;
        this.initialized = new Promise(function (resolve) {
            if (tokenFunctions === null || tokenFunctions === void 0 ? void 0 : tokenFunctions.hasToken) {
                tokenFunctions.hasToken().then(function () {
                    resolve();
                });
            }
            else {
                resolve();
            }
        });
    }
    HttpResource.prototype.getHeaders = function () {
        return this.tokenFunctions
            ? __assign(__assign({}, this.headers), { Authorization: 'Bearer ' + this.tokenFunctions.getToken() }) : this.headers;
    };
    HttpResource.prototype.GET = function (url, query) {
        var _this = this;
        var configuredUrl = this.convertQuery(url, query);
        return this.initialized.then(function () { return _this.fetchPromise(_this.baseUrl + configuredUrl, _this.getHeaders(), 'GET'); });
    };
    HttpResource.prototype.GET_TEXT = function (url) {
        var _this = this;
        return this.initialized.then(function () {
            return _this.fetchPromise(_this.baseUrl + url, _this.getHeaders(), 'GET', null, false);
        });
    };
    HttpResource.prototype.POST = function (url, data, headers) {
        var _this = this;
        return this.initialized.then(function () {
            var combinedHeaders = headers
                ? __assign(__assign({}, _this.getHeaders()), headers) : _this.getHeaders();
            return _this.fetchPromise(_this.baseUrl + url, combinedHeaders, 'POST', data ? (combinedHeaders['Content-Type'] === 'application/json' ? JSON.stringify(data) : data) : null);
        });
    };
    HttpResource.prototype.PUT = function (url, data, headers, parseJson) {
        var _this = this;
        return this.initialized.then(function () {
            var combinedHeaders = headers
                ? __assign(__assign({}, _this.getHeaders()), headers) : _this.getHeaders();
            return _this.fetchPromise(_this.baseUrl + url, combinedHeaders, 'PUT', data ? (combinedHeaders['Content-Type'] === 'application/json' ? JSON.stringify(data) : data) : null, typeof parseJson === 'undefined' ? true : parseJson);
        });
    };
    HttpResource.prototype.DELETE = function (url, data) {
        var _this = this;
        return this.initialized.then(function () {
            return _this.fetchPromise(_this.baseUrl + url, _this.getHeaders(), 'DELETE', JSON.stringify(data));
        });
    };
    HttpResource.prototype.checkStatus = function (response) {
        if (response.status >= 200 && response.status < 300) {
            return response;
        }
        return response.text().then(function (text) {
            var json = {};
            if (text) {
                try {
                    json = JSON.parse(text);
                }
                catch (e) {
                    console.warn('Could not parse response text: ' + text, e);
                }
            }
            // eslint-disable-next-line no-throw-literal
            throw { status: response.status, responseJSON: json };
        });
    };
    HttpResource.prototype.fetchByMethod = function (url, headers, method, data) {
        var options = {
            headers: headers,
            method: method,
            credentials: 'same-origin',
            body: undefined
        };
        if (data) {
            options.body = data;
        }
        return fetch(url, options);
    };
    HttpResource.prototype.runFetchByMethod = function (url, headers, method, resolve, reject, data, parseJson) {
        var _this = this;
        if (parseJson === void 0) { parseJson = true; }
        var tryFetch = function () {
            _this.fetchByMethod(url, headers, method, data)
                .then(_this.checkStatus)
                .then(function (response) {
                // Needs to check for empty responses as the API might return
                // empty response for status code 200
                response.headers.get('Content-Type') === 'application/pdf'
                    ? response.blob().then(function (blob) { return resolve(blob); })
                    : response
                        .text()
                        .then(function (text) {
                        resolve(text.length > 0 ? (parseJson ? JSON.parse(text) : text) : null);
                    })
                        .catch(function (e) {
                        reject(e);
                    });
            })
                .catch(function (e) {
                reject(e);
            });
        };
        tryFetch();
    };
    HttpResource.prototype.fetchPromise = function (url, headers, method, data, parseJson) {
        var _this = this;
        if (parseJson === void 0) { parseJson = true; }
        return new Promise(function (resolve, reject) {
            _this.runFetchByMethod(url, headers, method, resolve, reject, data, parseJson);
        });
    };
    HttpResource.prototype.convertQuery = function (url, query) {
        if (!query) {
            return url;
        }
        return url + Object.keys(query).reduce(function (acc, key) { return acc + "".concat(key, "=").concat(query[key], "&"); }, '?');
    };
    return HttpResource;
}());
exports.HttpResource = HttpResource;
